module.exports = __webpack_public_path__ + "static/media/bg-login-2.8e84af27.jpg";